import React, { useState, useEffect }  from 'react'
import { Table,  Space } from 'antd'
import Main from '../../../cpn/Main';
import ExpenseNodeDel from './ExpenseNodeDel';      
import ExpenseNodeAdd from './ExpenseNodeAdd';
import ExpenseNodeCheck from './ExpenseNodeCheck';
import ExpenseNodeCopyAdd from './ExpenseNodeCopyAdd';
import { useFYspjdListQuery } from '../../../store/DianShangYeWuApi';
function ExpenseNodeList() {
    const qy_id = JSON.parse(localStorage.getItem('jtg-caiwu_qy_id'))
    const qy_name = JSON.parse(localStorage.getItem('jtg-caiwu_qy_name'))
    const yh_id = JSON.parse(localStorage.getItem('jtg-caiwu_yh_id'))
    const yh_name = JSON.parse(localStorage.getItem('jtg-caiwu_yh_name'))
    const {data, isSuccess} = useFYspjdListQuery({fy_spjd_qy_id:qy_id});
    const [list, setList] = useState();
    useEffect(() => {
        if(isSuccess && data.Status === 'success' && data.Result){            
            // 找出所有不同的fy_spjd_user_id并合并
            const mergedArr = [];
            const userMap = {};
            data.Result.forEach(item => {
                // 用fy_spjd_user_id去合并
                if (item.fy_spjd_user_id && !userMap[item.fy_spjd_user_id]) {
                    userMap[item.fy_spjd_user_id] = {
                        key: item.fy_spjd_user_id,
                        fy_spjd_user_id: item.fy_spjd_user_id,
                        fy_spjd_user_name: item.fy_spjd_user_name,
                        fy_spjd_name: item.fy_spjd_name,
                        fy_spjd_yh_id: item.fy_spjd_yh_id,
                        fy_spjd_yh_name: item.fy_spjd_yh_name,
                        yh_id: item.fy_spjd_yh_id,
                        yh_name: item.fy_spjd_yh_name,
                    }
                    mergedArr.push(userMap[item.fy_spjd_user_id])
                }
            })
            setList(mergedArr);
        }else{
            setList([]);
        }
    }, [data, isSuccess])
    const columns = [
        {
            title: '费用单操作员',
            dataIndex: 'fy_spjd_user_name',
            key: 'fy_spjd_user_name',
            width: 300, 
            render: (text, record) => <Space>
                <ExpenseNodeCheck
                    user_id={record.fy_spjd_user_id}
                    user_name={record.fy_spjd_user_name}
                    qy_id={qy_id}
                    qy_name={qy_name}
                    yh_id={yh_id}
                    yh_name={yh_name}
                    fy_spjd_user_id={record.fy_spjd_user_id}
                    fy_spjd_user_name={record.fy_spjd_user_name}
                />
            </Space>
        },
        {
            title: '操作',
            key: 'action',
            render: (text, record) => <Space size={20}>
                <ExpenseNodeDel
                    fy_spjd_user_id={record.fy_spjd_user_id}                    
                />
                <ExpenseNodeCopyAdd
                    fy_spjd_user_id={record.fy_spjd_user_id}  
                    qy_id={qy_id}
                    qy_name={qy_name}
                    yh_id={yh_id}
                    yh_name={yh_name}
                />
            </Space>
        },
    ]
    return (
        <Main selectedKeys={['/ExpenseNodeList']}>
            <ExpenseNodeAdd  
                qy_id={qy_id}
                qy_name={qy_name}
                yh_id={yh_id}
                yh_name={yh_name}
            />
            <Table
                columns={columns}
                dataSource={list}
                style={{marginTop:'10px',width:'500px'}}
                className="custom-table"
                size='small'
                bordered
                rowKey="key"
            />
        </Main>
    )
}

export default ExpenseNodeList